import React from 'react'
import PropTypes from 'prop-types'
import {createUseStyles} from 'react-jss'

const useStyles = createUseStyles({
    input: {
        display: 'flex',
        flexDirection: 'column',
        width: '75%',
        marginTop: '8px'
    }
})

const InputLabel = (props) => {
    const styles = useStyles();
    const {label, type, name} = props
    return (
        <label className={styles.input}>
            {label}
            <input type={type} name={name}/>
        </label>
    );
}

InputLabel.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string
};

export default InputLabel